import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/children-day/2024/Index.vue')
const WishIndex = () => import('../activity/children-day/2024-wish/Index.vue')
const WishRecords = () => import('../activity/children-day/2024-wish/Records.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/children-day/2024',
  name: 'activity_children_day_2024',
  component: Index,
  meta: {
    title: '运动岛六一嘉年华',
    expiryDate: '2024-06-19',
  },
}

export const wishIndexRoute: RouteConfig = {
  path: '/activity/children-day/2024/wish',
  name: 'activity_children_day_2024_wish',
  component: WishIndex,
  meta: {
    title: '六一惊喜魔法瓶',
    expiryDate: '2024-06-19',
  },
}

export const wishRecordsRoute: RouteConfig = {
  path: '/activity/children-day/2024/wish/records',
  name: 'activity_children_day_2024_wish_records',
  component: WishRecords,
  meta: {
    title: '魔法水晶明细',
    expiryDate: '2024-06-19',
  },
}

export default []
